<template>
  <v-col class="mx-auto p-4" cols="12" lg="6" md="8">
    <!--            <h5 style="font-size: 12pt" class="btn btn-block btn-grad text-center text-white">{{ this.pageName }}</h5>-->
    <p v-if="this.breadcrumb.length === 0 && this.edit === false" class="pt-3">دسته آگهی مورد نظر خود را انتخاب
      کنید.</p>
    <a v-if="this.breadcrumb.length >= 1 && showCategory"
       class="btn btn-link text-decoration-none text-dark mb-2" @click="backCategory()">
      بازگشت به دسته اصلی
      <i class="fa fa-arrow-left text-dark mx-2"></i>
    </a>

    <nav v-if="breadcrumb.length > 0" aria-label="breadcrumb" class="breads mx-5 mt-5" @click="loadCategory()">
      <ol class="breadcrumb">
        <li v-for="item in breadcrumb" aria-current="page" class="breadcrumb-item mx-2">{{ item }}</li>
      </ol>
    </nav>

    <ul v-show="showCategory && this.edit === false" class="my-5" style="list-style: none">
      <input id="category" :value="current" name="category" required type="hidden" @change="getCurrent">
      <li v-for="item in category.filter((x) => x.parentSlug === current)" class="cursor-pointer py-2 px-5"
          style="font-size: 11pt;" @click="changeCategory(item)">
        <i v-for="x in catIcons.filter(y => y.slug === item.slug)" :class="x.icon"
           style="margin: 0 1rem;font-size: 14pt;color: #3F51B5"></i>
        <i v-if="item.parentSlug === 'root'"
           :class="'kt-icon kt-icon-' + item.slug + ' kt-icon--lg kt-base-row__icon'"></i>
        {{ item.title }}
        <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>
      </li>
      <li v-if="breadcrumb.length >=1" class="cursor-pointer py-2 px-5"
          style="font-size: 11pt;" @click="changeCategory(category.find((x) => x.slug === current))">
        متفرقه
        <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>
      </li>
    </ul>
  </v-col>
</template>

<script>

import {Bus} from "@/main";

export default {
  name: "agencyCategory",
  props: {
    auto_changes: {
      default: false,
      require: true
    },
    phone: {
      default: undefined,
    },
    multiAdsCat: {
      type: Boolean,
      default: true
    },
    pageName: {
      type: String,
      default: 'ثبت آگهی'
    },
    edit: {
      type: Boolean,
      default: false
    },
    edit_def: {
      type: Boolean,
      default: false
    },
    editCategory: {
      type: String,
      default: 'real-estate'
    },
    gradual: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      before: [],
      breadcrumb: [],
      showCategory: true,
      queryString: new URLSearchParams(),
      current: 'real-estate',
      Rp: [],
      timer: null,
      cityReq: '',
      category: [],
      singleFiltered: {
        "contact": null,
        "zoonkan_enabled": null,
        "category": null,
        "location": null,
        "optional_fields_description_section": null,
        "call_method": null,
        "other_options_and_attributes": null,
        "images": null,
        "hide_phone": null,
        "chat_enabled": null,
        "phone": null,
        "force_chat_enabled": null
      },
      multiFiltered: {
        "force_chat_enabled": null,
        "title": null,
        "user_type": null,
        "description": null,
        "hide_phone": null,
        "chat_enabled": null,
        "phone": null,
        "new_price": null,
        "contact": null,
        "zoonkan_enabled": null,
        "category": null,
        "location": null,
        "optional_fields_description_section": null,
        "images": null,
        "other_options_and_attributes": null,
        "colored_parts": null,
      },
      catIcons: [
        {icon: "fa fa-home", slug: "real-estate"},
        {icon: "fa fa-car", slug: "vehicles"},
        {icon: "fa fa-desktop", slug: "electronic-devices"},
        {icon: "fa fa-lightbulb", slug: "home-kitchen"},
        {icon: "fa fa-wrench", slug: "services"},
        {icon: "fa fa-user", slug: "personal"},
        {icon: "fa fa-dice", slug: "leisure-hobbies"},
        {icon: "fa fa-users", slug: "community"},
        {icon: "fa fa-industry", slug: "tools-materials-equipment"},
        {icon: "fa fa-briefcase", slug: "jobs"},
      ],
      forNational: []
    }
  },
  methods: {
    findSource(currentSlug) {
      if (currentSlug === 'real-estate') {
        this.before.push('real-estate');
        this.breadcrumb.reverse();
        this.before.reverse();
        this.before.pop();
        this.current = this.editCategory
        this.getFields(this.editCategory)
        return 'real-estate';
      }
      if (this.edit || this.edit_def) {
        const result = this.category.find((x) => x.slug === currentSlug);
        this.breadcrumb.push(result.title);
        this.before.push(result.slug);
        return this.findSource(result.parentSlug);
      }
    },
    loadCategory() {
      if (this.$data.showCategory)
        return;

      this.$data.showCategory = true;
      this.$data.current = this.$data.before.pop();
      this.$data.breadcrumb.pop();
    },
    backCategory: function () {
      if (this.before.length <= 0)
        return;

      this.current = this.before.pop();
      this.breadcrumb.pop();
    },
    changeCategory: function (item) {
      let search = this.category.filter(x => x.parentSlug === item.slug);

      if (search.length === 0 || this.current === item.slug) {
        this.showCategory = false;
        this.getFields(item.slug)
      }

      this.before.push(this.current);
      this.current = item.slug;
      this.breadcrumb.push(item.title);
    },
    getFields: function (slug, breadcrumb = true) {
      const vue = this;
      this.$data.showCategory = false;
      if (breadcrumb && vue.current !== 'real-estate')
        $.ajax(
          {
            url: `${url}/divar/categories/${slug}/dependency` + vue.queryString.toString(),
            type: 'POST',
            dataType: 'json',
            fn: this.getFields,
            headers: {
              'Authorization': Token,
              "Accept": "application/json"
            },
            success: function (data) {
              if (vue.multiAdsCat)
                vue.fields = data.data.filter((x) => {
                  if (Object.keys(vue.multiFiltered).includes(x.name)) {
                    vue.multiFiltered[x.name] = true;
                    return false;
                  }
                  return true;
                });
              else
                vue.fields = data.data.filter((x) => {
                  if (Object.keys(vue.singleFiltered).includes(x.name)) {
                    vue.singleFiltered[x.name] = true;
                    return false;
                  }
                  return true;
                });

              Bus.setProp("category_fields", vue.fields)
            }
          }
        );
    },
    generateQueryString(key, value) {
      this.queryString.delete(key);
      this.queryString.append(key, value);
      this.getFields(this.current, false);
    },
    getCategories() {
      const vue = this;
      $.ajax(
        {
          url: `${url}/divar/agency/categories`,
          type: "GET",
          fn: this.getCategories,
          dataType: "json",
          headers: {
            "ACCEPT": "application/json",
            Authorization: Token
          },
          success: function (data) {
            vue.category = data.data;
          }
        }
      )
    },
    Buses() {
      Bus.$emit('category-multi-filtered', this.multiFiltered);
      Bus.$emit('category-single-filtered', this.singleFiltered);
    },
    debounce(fn, timout = 1000) {
      clearTimeout(this.timer);
      this.timer = setTimeout(fn, timout);
    },
    getCurrent() {
      if (this.gradual === true) {
        this.getFields(this.current)
        this.debounce(function () {
          Bus.$emit('category-current', this.current)
        }, 500)
      } else
        return false;
    }
  },
  watch: {
    fields: function () {
      this.$emit('category-fields', this.fields);
      this.Buses();
    },
    current: {
      handler: function (value) {
        this.debounce(() => {
          Bus.setProp("category_current", value);
          Bus.$emit('category-current', value);
        }, 4000)
      },
      deep: true
    },
    auto_changes: function (value) {
      if (value === true) {
        this.getFields(this.current)
        this.debounce(function () {
          Bus.$emit('category-current', this.current)
        }, 500)
      } else
        return false;
    },
    cityReq: function () {
      const vue = this;
      if (vue.current !== 'real-estate') {
        const mine = $.ajax(
          {
            url: `${url}/divar/categories/${this.current}/dependency` + vue.queryString.toString(),
            type: 'POST',
            dataType: 'json',
            fn: this.mine,
            headers: {
              'Authorization': Token,
              "Accept": "application/json",
              "Content-Type": 'application/json'
            },
            data: JSON.stringify({
              "contact": {
                "phone": this.phone || undefined
              },
              "location": {
                "city": this.cityReq
              },
              "category": this.current,
              "images": [],
            }),
            success: function (data) {
              if (vue.multiAdsCat)
                vue.fields = data.data.filter((x) => {
                  if (Object.keys(vue.multiFiltered).includes(x.name)) {
                    vue.multiFiltered[x.name] = true;
                    return false;
                  }
                  return true;
                });
              else
                vue.fields = data.data.filter((x) => {
                  if (Object.keys(vue.singleFiltered).includes(x.name)) {
                    vue.singleFiltered[x.name] = true;
                    return false;
                  }
                  return true;
                });
              vue.forNational = vue.fields;
              Bus.setProp("category_fields", vue.fields);
            }
          }
        );
      }
    },
    forNational: function (value) {
      Bus.$emit('national', !!value.find((x) => x.name === "national_id"));
    },
    phone(val) {
      const vue = this;
      if (vue.current !== 'real-estate') {
        const mine = $.ajax(
          {
            url: `${url}/divar/categories/${this.current}/dependency` + vue.queryString.toString(),
            type: 'POST',
            dataType: 'json',
            fn: this.mine,
            headers: {
              'Authorization': Token,
              "Accept": "application/json",
              "Content-Type": 'application/json'
            },
            data: JSON.stringify({
              "contact": {
                "phone": this.phone || undefined
              },
              "location": {
                "city": this.cityReq
              },
              "category": this.current,
              "images": [],
            }),
            success: function (data) {
              if (vue.multiAdsCat)
                vue.fields = data.data.filter((x) => {
                  if (Object.keys(vue.multiFiltered).includes(x.name)) {
                    vue.multiFiltered[x.name] = true;
                    return false;
                  }
                  return true;
                });
              else
                vue.fields = data.data.filter((x) => {
                  if (Object.keys(vue.singleFiltered).includes(x.name)) {
                    vue.singleFiltered[x.name] = true;
                    return false;
                  }
                  return true;
                });
              vue.forNational = vue.fields;
              Bus.setProp("category_fields", vue.fields);
            }
          }
        );
      }
    }
  },
  beforeMount() {
    this.getCategories();
  },
  mounted() {

    Bus.$on('cityInfo', (value) => {
      this.cityReq = value.city
    });

    Bus.$on('selected_numbers', (value) => {
      this.phone = value
    });

    Bus.$on('getBreadCrumb', () => {
      this.before = [];
      this.breadcrumb = [];
      this.findSource(this.editCategory);
    })
  }
}
</script>

<style scoped>
.btn-grad {
  background-image: linear-gradient(to right, #000046 0%, #1CB5E0 51%, #000046 100%);
  text-align: center;
  text-transform: uppercase;
  transition: 0.7s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 20px #eee;
}

.btn-grad:hover {
  background-position: right center;
  /* change the direction of the change here */
  color: #fff;
  text-decoration: none;
  transition: 0.7s;
}
</style>